module.exports = __webpack_public_path__ + "img/document.c5216d08.svg";